import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoreHorizIcon(props: IconProps) {
    return <Icon {...props} iconKey={"more_horiz"}/>
}
